import { DesignSysEnvUtil } from './design-sys-env-util';

export const LogoUtil = {
  stripProtocol(url: string): string {
    return url.replace(/^(https?:\/\/)?(www\.)?/, '');
  },
  getUrl(domain: string | null | undefined): string | null {
    if (!domain) {
      return null;
    }
    const baseUrl = DesignSysEnvUtil.logoDevBaseUrl;
    const token = DesignSysEnvUtil.logoDevPublishableKey;
    const strippedDomain = LogoUtil.stripProtocol(domain);
    return `${baseUrl}/${strippedDomain}?token=${token}`;
  },
};
